module.exports = __webpack_public_path__ + "static/media/profile-card.60d259e7.svg";